<template>
  <div class="course-page">
    <div class="course-page__inner">
      <!-- carregando -->
      <page-skeleton v-if="loading" variant="list" class="mt-4" />

      <template v-else>
        <ModuleHero :module="course" :show-back="true" @back="goBack" />

        <div class="aulas__head">
          <p class="sec-label">
            {{ $t("partnerCourse.lessons") }}
            <span class="sec-count">{{ leassons.length }}</span>
          </p>
          <!-- Card 86akptec0: evolução do professor no treinamento -->
          <i18n
            v-if="isTraining && leassons.length"
            path="partnerCourse.summary"
            tag="p"
            class="tsummary"
          >
            <template #done>
              <strong>{{ completedCount }}</strong>
            </template>
            <template #total>{{ leassons.length }}</template>
            <template #percent>{{ completedPercent }}</template>
          </i18n>
        </div>

        <div v-if="leassons.length > 0" class="list">
          <LessonRow
            v-for="(item, index) in leassons"
            :key="item.id || index"
            :item="item"
            :accent="accent"
            :order="index + 1"
            :completed="isTraining && completedIds.includes(String(item.id))"
            @open="goToCourse"
          />
        </div>

        <div v-else class="aulas__empty">
          <i class="mdi mdi-stairs"></i>
          <p>{{ $t("partnerCourse.empty") }}</p>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import ModuleHero from "@/components/connect/course/ModuleHero.vue";
import LessonRow from "@/components/connect/course/LessonRow.vue";
import { tierColor, TRAINING_COLOR } from "@/shared/courseTiers";
import pitchPartnerApi from "@/shared/pitchPartnerApi";

export default {
  name: "CourseArea",
  components: {
    ModuleHero,
    LessonRow,
  },
  async created() {
    this.loading = true;
    await pitchPartnerApi
      .getCourseById(this.$route.params.id)
      .then((response) => {
        this.loading = false;
        this.course = response.data.content;
        this.leassons = response.data.content.classes || [];
        this.isTraining = !!response.data.isTraining;
        this.completedIds = (response.data.completedClassIds || []).map(String);
      })
      .catch(() => {
        this.loading = false;
        this.$root.$emit("display-alert", {
          text: this.$t("partnerCourse.loadFailed"),
          type: 2,
          timeout: 1000,
        });
      });
  },
  data() {
    return {
      loading: false,
      course: {},
      leassons: [],
      // Card 86akptec0: treinamento traz as aulas já concluídas.
      isTraining: false,
      completedIds: [],
    };
  },
  computed: {
    accent() {
      return this.isTraining ? TRAINING_COLOR : tierColor(this.course.level);
    },
    completedCount() {
      return this.leassons.filter((item) =>
        this.completedIds.includes(String(item.id))
      ).length;
    },
    completedPercent() {
      if (!this.leassons.length) return 0;
      return Math.round((this.completedCount / this.leassons.length) * 100);
    },
    // Card 86akqwmzy: treinamento vive na aba Treinamentos; módulo do curso,
    // na aba Materiais. Links antigos (/curso/:id) de treinamento também
    // voltam para Treinamentos.
    basePath() {
      const trainings = "/connect/professor/treinamentos";
      return this.isTraining || this.$route.path.startsWith(`${trainings}/`)
        ? trainings
        : "/connect/professor/curso";
    },
  },
  methods: {
    goBack() {
      this.$router.push({ path: this.basePath });
    },
    async goToCourse(item) {
      await this.$router.push({
        path: `${this.basePath}/${this.$route.params.id}/${item.id}`,
        params: item.id,
      });
    },
  },
};
</script>

<style scoped>
.course-page {
  padding: clamp(20px, 4vw, 44px) clamp(16px, 4vw, 40px) 72px;
}
.course-page__inner {
  max-width: 1180px;
  margin: 0 auto;
}
.aulas__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}
.sec-label {
  margin: 0 0 18px;
  font-family: "Poppins", sans-serif;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--dk-faint, #9a96a6);
}
.tsummary {
  margin: 0 0 18px;
  font-family: "Poppins", sans-serif;
  font-size: 13px;
  color: var(--dk-ink-soft, #6e6a79);
}
.tsummary strong {
  color: var(--dk-ink, #211b2e);
}
.sec-count {
  display: inline-grid;
  place-items: center;
  min-width: 22px;
  height: 20px;
  padding: 0 7px;
  margin-left: 4px;
  border-radius: 999px;
  background: var(--dk-line, #f1eef7);
  color: var(--dk-ink-soft, #6e6a79);
  font-size: 11px;
  letter-spacing: 0;
  vertical-align: middle;
}
.list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.aulas__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 48px 24px;
  border: 1px dashed var(--dk-line-strong, #ded9e8);
  border-radius: 18px;
  text-align: center;
  color: var(--dk-ink-soft, #6e6a79);
  font-family: "Poppins", sans-serif;
  font-size: 14px;
}
.aulas__empty .mdi {
  font-size: 34px;
  color: var(--dk-line-strong, #c9c4d4);
}
.course-page__state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px 0;
  font-family: "Poppins", sans-serif;
  color: var(--dk-ink-soft, #6e6a79);
}
</style>
